import { AdminDashboardDataFilter, AdminDashboardVenuesStatsResponse } from '../../graphql/API';
import { adminGetDashboardVenuesStatsData } from '../../graphql/queries';
import { executeGql, processGqlResult } from '../../utils/gql-utils';

export const adminGetDashboardVenuesStatsDataApi = async (
  filter: AdminDashboardDataFilter,
): Promise<AdminDashboardVenuesStatsResponse> => {
  const result = await executeGql(adminGetDashboardVenuesStatsData, { filter });
  return processGqlResult<AdminDashboardVenuesStatsResponse>(
    'adminGetDashboardVenuesStatsData',
    result,
  );
};
